















































import { defineComponent, ref, PropType } from "@vue/composition-api";
import * as DeviceUtils from "@/utils/device";
import { SetupContext, SetupResult } from "../ts/DeviceSetup";
import { AbsBox, Icon } from "@ui";
import { Translate } from "@lang";

export default defineComponent({
	emits:[
		"done",
	],
	props:{
		context:{
			type:Object as PropType<SetupContext>,
			required:true,
		}
	},
	components:{
		AbsBox,
		Icon,
		Translate,
	},
	setup(props, context){
		
		const accelerometerEnabled = ref(false);
		const done = () => {
			const r:SetupResult = {
				accelerometerEnabled:accelerometerEnabled.value,
			};
			context.emit("done", r);
		};

		const confirm = async () => {
			accelerometerEnabled.value = await DeviceUtils.hasDeviceOrientation();
			done();
		};

		return {
			confirm,
		};
	}
});

